import React, { memo, useContext } from 'react';
import { Divider, makeStyles } from '@material-ui/core';
import { CloudOff } from '@material-ui/icons';
import { ChapterList, Message, UsageBar } from 'components';
import CopiedContentListItem from 'components/CopiedContentMenu/CopiedContentListItem';
import {
  DRMValuesContext,
  NetworkStatusValuesContext,
  UserContentValuesContext,
} from 'contexts';

const useStyles = makeStyles((theme) => ({
  root: {
    fontFamily: theme.typography.fontFamily,
    width: '100%',
    maxWidth: 256,
    border: `1px solid ${theme.palette.divider}`,
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  menuHeader: {
    margin: theme.spacing(2),
  },
}));

const messageProps = {
  text: `You're currently offline. Links to content that have not been downloaded are unavailable. You will not be able to copy new content while offline.`,
  icon: <CloudOff />,
  shouldHaveAction: false,
  shouldHaveBorderRadius: false,
};

const createCopiedContentList = (userContent) => {
  if (!userContent?.copiedTextsByTopLevelMarker) {
    return null;
  }

  return Array.from(userContent.copiedTextsByTopLevelMarker);
};

export const CopiedContentMenu = ({ defaultExpanded = false, ...props }) => {
  const classes = useStyles();

  const { copyPercentMaximum, copyPercentRemaining, copyPercentUsed } =
    useContext(DRMValuesContext);

  const { isOffline } = useContext(NetworkStatusValuesContext);
  const userContent = useContext(UserContentValuesContext);

  const copiedContents = createCopiedContentList(userContent);

  return (
    <div className={classes.root} {...props}>
      <div className={classes.menuHeader}>
        <UsageBar
          id="copy-menu-drm"
          usageText="Previously Copied"
          currentPercent={copyPercentUsed}
          availablePercent={copyPercentMaximum}
          remainingAllowance={copyPercentRemaining}
        />
      </div>
      <Divider />
      {isOffline && <Message {...messageProps} />}
      {copiedContents ? (
        <ChapterList>
          {copiedContents.map(
            ([key, value]) =>
              value.length > 0 && (
                <CopiedContentListItem
                  defaultExpanded={defaultExpanded}
                  isOffline={isOffline}
                  key={key ? key.index : 'no-chapter'}
                  topLevelMarker={key}
                >
                  {value}
                </CopiedContentListItem>
              ),
          )}
        </ChapterList>
      ) : null}
    </div>
  );
};

export default memo(CopiedContentMenu);
